import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  InformationAlert,
  InformationAlertDescription,
  InformationAlertTitle
} from 'components/informationAlert';
import { I18n } from 'components/translate';
import { FeatureToggles, FeatureToggleService } from 'modules/featureToggle';
import { PropTypes } from 'prop-types';

import ConfigStreamingToggle from './ConfigStreamingToggle';
import ImportantCard from './ImportantCard';

import { BetaBadge } from '../../../components/betaBadge';
import StaticLink from '../../../components/staticLink/StaticLink';
import { STATIC_LINKS } from '../../dashboard/constants';
import ConfigList from '../components/ConfigList';

import './ConfigDrm.scss';

const ConfigDrm = ({ active, streamingActive, onChange, activatingDrm }) => {
  const items = [
    {
      label: 'config_manager.config_streaming.drm.benefit_free_beta',
      icon: 'wallet',
      iconSize: 16
    },
    {
      label: 'config_manager.config_streaming.drm.benefit_screen_recording',
      icon: 'phone-laptop',
      iconSize: 16
    },
    {
      label: 'config_manager.config_streaming.drm.benefit_download',
      icon: 'arrow-alt-to-bottom',
      iconSize: 16
    },
    {
      label: 'config_manager.config_streaming.drm.benefit_security',
      icon: 'shield-check',
      iconSize: 16
    }
  ];

  const disabled = !streamingActive;
  const deviceList = FeatureToggleService.isEnabled(
    FeatureToggles.ConfigDrmDeviceList
  );

  return (
    <div className="grid grid__block config-drm">
      <h2 className="mb__md config-drm__title">
        <I18n label="config_manager.config_streaming.drm.title" />
        <BetaBadge size="lg" />
      </h2>
      <p>
        <I18n html label="config_manager.config_streaming.drm.description" />
      </p>

      <h3 className="config-drm__benefits">
        <I18n label="config_manager.config_streaming.drm.benefits" />
      </h3>

      <ConfigList items={items} />

      <ConfigStreamingToggle
        toggleId="drm"
        label="config_manager.config_streaming.drm.activate_question"
        checked={disabled ? false : active}
        onChange={onChange}
        disabled={disabled}
      />

      {disabled && (
        <InformationAlert>
          <InformationAlertTitle>
            <I18n label="config_manager.config_streaming.drm.availability_title" />
          </InformationAlertTitle>
          <InformationAlertDescription>
            <I18n label="config_manager.config_streaming.drm.availability_description" />
          </InformationAlertDescription>
        </InformationAlert>
      )}

      {activatingDrm && (
        <InformationAlert>
          <InformationAlertDescription>
            <I18n label="config_manager.config_streaming.drm.activating" />
          </InformationAlertDescription>
        </InformationAlert>
      )}

      {deviceList && (
        <ImportantCard title="config_manager.config_streaming.drm.view_warning">
          <StaticLink
            links={STATIC_LINKS.DRM_COMPATIBLE_DEVICES}
            className="streaming__important__link"
          >
            <I18n label="config_manager.config_streaming.drm.device_list" />
            <FontAwesomeIcon
              icon={['fal', 'external-link']}
              className="_ml-2"
            />
          </StaticLink>
        </ImportantCard>
      )}
    </div>
  );
};

ConfigDrm.propTypes = {
  active: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  streamingActive: PropTypes.bool.isRequired,
  activatingDrm: PropTypes.bool.isRequired
};

export default ConfigDrm;
